import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import "firebase/compat/auth"; // ✅ أضفنا الـ Authentication

// firebase config
const firebaseConfig = {
  apiKey: "AIzaSyB0LrtFnLZWWBEc2w9ZP-XZ6oo0cXaj0Ps",
  authDomain: "adba-ac0ef.firebaseapp.com",
  projectId: "adba-ac0ef",
  storageBucket: "adba-ac0ef.firebasestorage.app",
  messagingSenderId: "1024311923017",
  appId: "1:1024311923017:web:99333c72c84b1c8d5a4a98",
  measurementId: "G-2W4JEDRFQF",
};

// initialize
const app = firebase.initializeApp(firebaseConfig);
const db = app.firestore();
const storage = app.storage();
const auth = app.auth(); // ✅ أنشأنا متغير خاص بالـ Authentication

export { db, storage, auth };
